module.exports = {"normal":"정상","abnormal":"비정상","closedHole":"휴장홀","normalOperationRate":"정상 가동률","spareParts":"예비품","pinStandard":"핀 규격","pinChangeMethod":"핀 교체 방식","batteryLevel":"배터리 잔량","batteryWarning":"배터리 경고","pinFlipped":"핀 뒤집힘","storage":"보관","noData":"데이터가 없습니다."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cd002.json
// module id = DwiL
// module chunks = 2